module.exports = __webpack_public_path__ + "img/Infection_Outbreak_Beta.0bf4f67c.jpg";